
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { jk } from '@/authors'
export const meta = {
  title: '2021Q2 Product Updates',
  description: `
As a lean startup, we are evolving every day, being open to changes in customer expectation to industry needs. We believe all of our success and customer success depends on the continuous improvement on everything we do. `,
  date: '2021-09-01T15:43:02.988Z',
  authors: [jk]
};
export const slug = '2021-09-01-sept';
export const tableOfContents = [{
  "title": "Focus on Headless API Product",
  "slug": "focus-on-headless-api-product",
  "children": [{
    "title": "Open Source App Kits",
    "slug": "open-source-app-kits",
    "children": []
  }]
}, {
  "title": "Additional Service and Product Offering through marketplace ecosystem",
  "slug": "additional-service-and-product-offering-through-marketplace-ecosystem",
  "children": []
}, {
  "title": "New API Functionalities.",
  "slug": "new-api-functionalities",
  "children": [{
    "title": "In-app payments (Google and Apple)",
    "slug": "in-app-payments-google-and-apple",
    "children": []
  }, {
    "title": "Listing variance",
    "slug": "listing-variance",
    "children": []
  }, {
    "title": "New payment gateways for the Middle East Countries",
    "slug": "new-payment-gateways-for-the-middle-east-countries",
    "children": []
  }, {
    "title": "Search & filter improvements across the app (Especially attribute searches)",
    "slug": "search-and-filter-improvements-across-the-app-especially-attribute-searches",
    "children": []
  }, {
    "title": "Map View for listing browsing",
    "slug": "map-view-for-listing-browsing",
    "children": []
  }]
}, {
  "title": "Enhancement in SuperAdmin",
  "slug": "enhancement-in-super-admin",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`We have been continuously finding ways to improve the product and customer expectations. With change always in mind, we have got the below updates to be shared. If you have got any feedback, share it with us.`}</p>
    <p>{`We would like to share what we will be focusing on in the new few months and product updates.`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Additional focus on Headless API Product`}</li>
      <li parentName="ol">{`Introducing Marketplace Ecosystem`}</li>
      <li parentName="ol">{`Product Updates`}</li>
    </ol>
    {/*more*/}
    <_Heading level={2} id={"focus-on-headless-api-product"} nextElement={{
      "type": "paragraph"
    }}>Focus on Headless API Product</_Heading>
    <p>{`API first product is the core pillar of our solution offering. Increasing the focus and allocating more resources to API products will make`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`New product features `}</li>
      <li parentName="ul">{`Easy for partners(developers/agencies) to build applications (Action items like an enhancement to documentation and API Reference) `}</li>
      <li parentName="ul">{`Open-source front end starter kits to speed up the development of apps `}</li>
    </ul>
    <_Heading level={3} id={"open-source-app-kits"} nextElement={{
      "type": "paragraph"
    }}>Open Source App Kits</_Heading>
    <p>{`To speed up the development of front-end apps for the Headless product, we will be releasing new starter kits. We have developed three front-end (apps) starter kits. Few are already open-sourced and others will be available soon. These apps are built on top of Tradly API. If you are a developer, We welcome your feedbacks.`}</p>
    <p>{`1.`}<strong parentName="p">{` ReactJs Web template`}</strong>{`
Use Cases: Product Marketplaces
Status of development: Intermediate
GitHub Link ( ⭐️  it and watch for updates)`}</p>
    <p><strong parentName="p">{`2. React Native`}</strong>{`
Use Case: Event Marketplaces, Service Marketplaces which involve calendaring system
Status of development: Advanced
Github: Yet to be open-sourced (in a week or so) `}</p>
    <p><strong parentName="p">{`3. React Native`}</strong>{`
Use cases: Recycle management, finding bins, collection point, etc
Status of development: Basic
Github: Available within this September`}</p>
    <p><strong parentName="p">{`4. Flutter App`}</strong>{`
Use cases: Buyer-focused app for B2C brands /Grocery Shopping, etc.
Status of development: Basic
Github Link (⭐️ it and watch for updates)`}</p>
    <_Heading level={2} id={"additional-service-and-product-offering-through-marketplace-ecosystem"} nextElement={{
      "type": "paragraph"
    }}>Additional Service and Product Offering through marketplace ecosystem</_Heading>
    <p><strong parentName="p">{`Now you can own the Mobile Application Code`}</strong>{` `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`PS: Not to confuse with the headless API / Backend source code`}</li>
      <li parentName="ul">{`There are cases where you want to change the way the app looks or user experience. But don’t want to develop from scratch to avoid risks and time.`}</li>
      <li parentName="ul">{`You can buy the code directly in our marketplace. The Marketplace will have own code and partner codes as well. `}</li>
    </ul>
    <p><strong parentName="p">{`Inviting Partner Development Agencies`}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`We will be inviting new front-end development agencies to help with your custom app developments. `}</li>
      <li parentName="ul">{`They will be progressively onboarded in the coming months.`}</li>
      <li parentName="ul">{`Do reach out to us if you are a developer or agencies wants to develop an application and sell it to our customers. `}</li>
    </ul>
    <p><strong parentName="p">{`Advanced integrations as extensions `}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Extensions/addons is advanced integrations and unique functionalities for different types of marketplaces `}</li>
      <li parentName="ul">{`We have 20+  as of now from partner development agencies and in-house. We will be continuing to add more add-ons + providing suggestions to partner development agencies on what they can develop for you. `}</li>
    </ul>
    <p>{`Feature updates `}</p>
    <_Heading level={2} id={"new-api-functionalities"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>New API Functionalities.</_Heading>
    <_Heading level={3} id={"in-app-payments-google-and-apple"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>In-app payments (Google and Apple)</_Heading>
    <_Heading level={3} id={"listing-variance"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Listing variance</_Heading>
    <_Heading level={3} id={"new-payment-gateways-for-the-middle-east-countries"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>New payment gateways for the Middle East Countries</_Heading>
    <_Heading level={3} id={"search-and-filter-improvements-across-the-app-especially-attribute-searches"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>Search & filter improvements across the app (Especially attribute searches)</_Heading>
    <_Heading level={3} id={"map-view-for-listing-browsing"} nextElement={{
      "type": "paragraph"
    }}>Map View for listing browsing</_Heading>
    <p>{`Plus dozen of minor improvements. `}</p>
    <_Heading level={2} id={"enhancement-in-super-admin"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Enhancement in SuperAdmin</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Email templates customization from SuperAdmin  (System emails going out can be customized) `}</li>
    </ul>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;